export default "__VITE_ASSET__CefK1gYl__"